import React, { useState, useEffect, useRef } from "react";
import styles from "./product-available.module.scss";
import { MdChevronRight } from "react-icons/md";
interface ProductAvailableProps {
    onClickUrl: string;
    qtd: string;
}

export const ProductAvailable: React.FC<ProductAvailableProps> = ({  onClickUrl, qtd }) => {

    return (
        <a href={`${onClickUrl}`} aria-hidden="true" target="_blank" className={styles.products} rel="noreferrer">
            <div className={styles.products__line}>
                <button className={styles.products__txt}>
                    {qtd} produtos disponíveis
                    <span></span>
                </button>
                <MdChevronRight className={styles.products__arrow} />
            </div>
        </a>
    );
};
